// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "._404_title_2zcsz {\n  text-align: center;\n}", "",{"version":3,"sources":["/opt/buildhome/repo/src/router/views/_404.vue"],"names":[],"mappings":"AA2CA;EACE,kBAAA;AA1CF","file":"_404.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.title\n  text-align: center\n"]}]);
// Exports
exports.locals = {
	"title": "_404_title_2zcsz"
};
module.exports = exports;
